import { IPurchaseProduct } from '@/fsd/entities/product/model/types/IPurchaseProduct';

export const isProductChanged = (
  currentProduct: IPurchaseProduct,
  initialProduct: IPurchaseProduct
) => {
  const hasChanged =
    (currentProduct.count ?? 0) !== (initialProduct.count ?? 0) ||
    (currentProduct.price ?? 0) !== (initialProduct.price ?? 0) ||
    (currentProduct.count_plan ?? 0) !== (initialProduct.count_plan ?? 0) ||
    (currentProduct.count_fact ?? 0) !== (initialProduct.count_fact ?? 0) ||
    (currentProduct.count_diff ?? 0) !== (initialProduct.count_diff ?? 0) ||
    (currentProduct.quantity ?? 0) !== (initialProduct.quantity ?? 0);

  return hasChanged;
};
